.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--status-warning-fg);
  border-left-width: 4px;
  border-radius: var(--radius-control);
  background: var(--status-warning-bg);
}

.panel[data-danger] {
  border-color: var(--danger);
  background: var(--danger-tint);
}

.title {
  margin: 0;
  font: var(--t-body-strong);
  color: var(--ink);
}

.panel[data-danger] .title {
  color: var(--danger);
}

.body {
  font: var(--t-body);
  color: var(--graphite);
}
